import { z } from 'zod';
export const EstimatesParameterSchema = z.enum(['ESTIMATES_BASE_URL']);
export const EstimatesParameterEnum = EstimatesParameterSchema.enum;
